import type { StoryAsset, StoryDocument, StorySettings } from '../shared/story';

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(path, init);
  const data = await response.json();
  if (!response.ok) throw new Error(data.error?.message || 'The story could not be loaded. Please retry.');
  return data;
}
export type StoryImport = {
  assets: StoryAsset[];
  slideSeconds: number[];
  suggestedTracks: StorySettings['tracks'];
};
export const storyApi = {
  get: () => request<StoryDocument>('/api/story'),
  edit: () => request<StoryDocument>('/api/admin/story'),
  save: (settings: StorySettings, csrf: string) =>
    request<StoryDocument>('/api/admin/story', {
      method: 'PUT',
      headers: { 'content-type': 'application/json', 'x-csrf-token': csrf },
      body: JSON.stringify(settings),
    }),
  upload: (
    kind: 'powerpoint' | 'video' | 'audio',
    file: File,
    csrf: string,
    progress: (percent: number) => void,
  ) =>
    new Promise<StoryImport>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', `/api/admin/story/import/${kind}`);
      xhr.setRequestHeader('x-csrf-token', csrf);
      xhr.timeout = 600000;
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) progress(Math.round((event.loaded / event.total) * 100));
      };
      xhr.onerror = () => reject(new Error('Connection lost. Reconnect and retry the file.'));
      xhr.ontimeout = () =>
        reject(new Error('Preparing this file took too long. Try a smaller file or use the MP4 version.'));
      xhr.onload = () => {
        try {
          const data = JSON.parse(xhr.responseText);
          if (xhr.status >= 200 && xhr.status < 300) resolve(data);
          else reject(new Error(data.error?.message || 'The file could not be imported.'));
        } catch {
          reject(new Error('The server could not confirm the import. Please retry.'));
        }
      };
      const form = new FormData();
      form.append('file', file);
      xhr.send(form);
    }),
};
